export const DOMAIN_NAME = 'corp.ncr.com';
export const FILEKEY = 'XLR $ POS';
// TODO: Remove this timeout or make it based on things actually loading.
export const RTI_BASEURL = 'localhost';
export const POS_SERVICE_TYPE_URL = 'api/pos-service-type';
export const XLR_CONFIG_URL = 'api/xlr-runtime-configuration';
export const EDGE_IAM_CONFIG_URL = 'api/openid-configuration';
export const DEFAULT_RDS_PORT = process.env.REACT_APP_RDS_PORT ?? 8082;
export const BASE_RDS = process.env.REACT_APP_RDS_HTTP_URL ?? `localhost`;
export const RDS_DEVICES = '/connect';
export const RDS_SCALE_CONTROLLER = '/scale';
export const RDS_READWEIGHT = '/read-weight';
export const DEFAULT_RPS_PORT = process.env.REACT_APP_RPS_PORT ?? 8080;
export const RPS_PAYMENT_URL = process.env.REACT_APP_RPS_HTTP_URL ?? `localhost`;
export const THANK_YOU_LIFE_SPAN = 4000;
export const SAVE_TIME_OUT = 1000;
export const VOID_TIME_OUT = 1000;
export const LOAD_TIME_OUT = window.Cypress ? 0 : 300;
// TODO: Move these values to theme?
export const vSpacing = `${(10 / 768) * 100}vh`;
export const hSpacing = `${(10 / 1366) * 100}vw`;
export const DEBOUNCE_TIMEOUT: number = 250;
export const NOT_IMPLEMENTED_CLASS: string = 'not-implemented';
export const DEFAULT_TENDER_ID = '1';
export const HEALTH_CHECK_TIMEOUT: number = 10000;

//This shouldn't be here. We need to have another config file like POS.config(from the POS code)
export const PRODUCT_DESCRIPTION_TYPE_TO_DISPLAY = 'Short';
export const DEPARTMENT_SALE_TOP_LABEL: string = 'Select / Enter Department ID';
export const DEPARTMENT_SALE_TOP_LABEL_PRICE: string =
  'Enter the item’s price and<br />select ‘Approve Price’';
export const FORCE_QUANTITY_KEYPAD_TOP_LABEL: string = "Enter item's quantity and select 'Approve'";
export const MERGE_TRANSACTION_KEYPAD_TOP_LABEL: string =
  'Enter/Type transaction code and press OK';
//This needs to go into a dictionary instead but doing this for now.
export const PRICE_ENTRY_KEYPAD_TOP_LABEL: string = "Enter price, click 'OK' to continue.";
